'use strict';

angular.module('app')
  .service('SearchLiveaboard', function($injector, $location, utils, Request, check404) {
    return {
      getLocationData: function(slug) {
        return Request.get('search/liveaboards/' + slug + '/').then(function(res){
          if (res.data.allLanguageSlugs) {
            var $rootScope = $injector.get('$rootScope');
            $rootScope.allLanguageSlugs = res.data.allLanguageSlugs;
          }
          return res.data;
        });
      },
      getList: function (pageNum, data, location) {
        if (!data) { data={}; }
        angular.extend(data,pageNum);


        if (data.departure_date_custom) {
          data.departure_date = data.departure_date_custom;
          data.departure_date_custom = null;
        }

        return Request.get('search/' + location.model.toLowerCase() + '/' + location.pk + '/liveaboards/',data).then(function(res) {
          _.each(res.data.results, function(val) {
              if (val.teaser) {
                val.teaser = val.teaser.replace(/<h2>/g, '')
                          .replace(/<li>/g, '')
                          .replace(/<strong>/g, '')
                          .replace(/<ul>/g, '')
                          .replace(/<p>/g, '')
                          .replace(/<\/li>/g, '\n')
                          .replace(/<\/strong>/g, '')
                          .replace(/<\/ul>/g, '')
                          .replace(/<\/p>/g, '\n')
                          .replace(/<\/h2>/g, '\n');
              }

              if (_.find(val.promotions,{isMain: true})) {
                val.promotions = _.sortBy(val.promotions, 'isMain').reverse();
              } else {
                val.promotions = _.sortBy(val.promotions, 'value').reverse();
              }
          });
          if (utils.setNoIndex) {
            utils.setNoIndex(res.data.count !== 0 ? true : false);
          }
          if (utils.setPrevNextUrl) {
            utils.setPrevNextUrl(pageNum.page, res.data.next); 
          }
          return res.data;
        }).catch(function(error) {
          if (utils.setNoIndex) {
            utils.setNoIndex(true);
          }

          if (error.status == '404') {
            check404.checkUrlStatus();
          }

          return {
            count: 0,
            results: []
          }
        })
      },
      getByDates: function (data, location, pageNum) {
          if (!data) { data={}; }
          angular.extend(data,pageNum);

          data.page_size = 50;

          if (data.departure_date_custom) {
            data.departure_date = data.departure_date_custom;
            data.departure_date_custom = null;
            data.infinity_fx35 = true;
          }

          return Request.get('search/' + location.model.toLowerCase() + '/' + location.pk + '/trips/',data).then(function (res) {
            var groupedByDates = _.groupBy(res.data.results,'startDate'),
                obj = {};

            _.each(groupedByDates, function (val,key) {
                var i = 0;

                _.each(val, function (v) {
                    if (!v.availableSpots) {
                      i++;
                    } else {
                      if (!obj[key]) {
                        obj[key] = [];
                      }

                      obj[key].push(v);
                    }
                });

                if (obj[key] && obj[key][0]) {
                  obj[key][0].totalSpotsSells = i;
                }
            });

            return {
              count: res.data.count,
              results :_.map(obj)
            };
          });
      },
      getTrips: function (id, url, filters, revert) {
        var params = {};

        if (url) {
          var newUrl = url.split('page=')[1];
          params = {page: newUrl.split('&')[0] };
        }

        if (params.departure_date_custom) {
          params.departure_date = params.departure_date_custom;
          params.departure_date_custom = null;
        }

        angular.extend(params,filters);

        if (revert) {
          params.departure_date_less_then = params.departure_date;

          delete params.departure_date;
        }

        return Request.get('search/liveaboards/' + id + '/trips/', params).then(function(res) {
          res.data.revert = revert;

          if (revert) {
            res.data.results.reverse();
          }

          return res.data;
        });
      },
      getFilters: function(location) {
        return Request.get('search/' + location.model.toLowerCase() + '/' + location.pk + '/liveaboards/filters/').then(function(res){
          return res.data;
        });
      },
      getTag: function (tagName, location) {
        return Request.get('search/' + location.model.toLowerCase() + '/' + location.pk + '/tags/' + tagName + '/').then(function(res){
          return res.data;
        });
      },
      generateLAUrl: function (shop, trip) {
        var query = '?';

        if ($location.search().duration) {
          _.each($location.search().duration, function(val) {
            query += 'duration=' + val + '&';
          });
        }

        if ($location.search().harbours) {
          _.each($location.search().harbours, function(val) {
            query += 'harbours=' + val + '&';
          });
        }

        if (trip) {
            query += 'trip_id=' +  trip.id + '&trip_date=' + moment(trip.startDate).format('YYYY-MM-DD');
        }

        if (query === '?') {
          query = '';
        }

        return '/liveaboard/' + (shop.referenceLocationCountrySlug || shop.countrySlug) + '/' + (shop.slug || shop.shopSlug)  + '/' + query;
      },
      generateQueryLAUrl: function (trip) {
        var query = '?';

        if ($location.search().duration) {
          _.each($location.search().duration, function(val) {
            query += 'duration=' + val + '&';
          });
        }

        if ($location.search().harbours) {
          _.each($location.search().harbours, function(val) {
            query += 'harbours=' + val + '&';
          });
        }

        if ($location.search().aid) {
          query += 'affiliate_' + $location.search().aid + '&aid=' + $location.search().aid + '&'

          if ($location.search().cid) {
              query += 'cid=' + $location.search().cid + '&'
          }
      }

        if (trip) {
            query += 'trip_id=' +  trip.id + '&trip_date=' + moment(trip.startDate).format('YYYY-MM-DD');
        }

        if (query === '?') {
          query = '';
        }

        return query;
      },
      generateItineraryUrl: function (shop) {
        return this.generateLAUrl(shop) + '/' + shop.itinerarySlug;
      }
    };
  });